export default __webpack_public_path__ + "static/media/In the mountains-mini.318f9096.jpg";